export {default} from './ShadowFooter';
